class AppUrl{
    // static BaseURL = 'http://127.0.0.1:8000/api';
    static BaseURL = 'https://app.soyaninitiative.org/api';

    // Web base (no /api) — used for file download routes
    // static BaseWebURL = 'http://127.0.0.1:8000';
    static BaseWebURL = 'https://app.soyaninitiative.org';
    static DownloadAnnualReport = AppUrl.BaseWebURL + '/download/annual/report/';

   // --------------footer----------------------
   static Footer = this.BaseURL+'/footer';

   // --------------recent projects----------------------
   static Recentprojectshome = this.BaseURL+'/projecthome';
   static Recentprojectsall = this.BaseURL+'/projectall';
   static Projectdetails = this.BaseURL+'/projectdetails/';
   static categories = this.BaseURL+'/categories';
   static allprojectsindetails = this.BaseURL+'/allprojectsindetails';


   // --------------recent projects----------------------
   static logo = this.BaseURL+'/logo';
   static homebanner = this.BaseURL+'/homebanner';
   



   
    //---------------event routes-----------------------
    static Eventshome = this.BaseURL+'/eventhome';
    static Eventsall = this.BaseURL+'/event/all';
    static Eventsdetails = this.BaseURL+'/eventdetails/';

    //-------------service routes----------------
    static Servicehome = this.BaseURL+'/servicehome';

    //-------------Gallery photos home routes----------------
    static photos = this.BaseURL+'/galleryhome';
    static allphotos = this.BaseURL+'/galleryall';

    
    //-------------video home----------------
    static videos = this.BaseURL+'/galleryvideohome';
    static allvideos = this.BaseURL+'/galleryvideoall';
    
// ---------------------------company------------------------
   static Company = this.BaseURL+'/company';
    
    //-------------team photos routes----------------
    static teamhome = this.BaseURL+'/teamhome';
    static allteams = this.BaseURL+'/allteams';


     //-------------count routes----------------
     static Counthome = this.BaseURL+'/counthome';

    //about routes
    static Abouthome = this.BaseURL+'/abouthome';
    static CoreValues = this.BaseURL+'/core-values';
    static Objectives = this.BaseURL+'/objectives';


     
     //all team routes
     static allevents = this.BaseURL+'/event/all';
     
     //contact
     static contactSend = this.BaseURL+'/contactSend';

     
     //donate api
     static donate = this.BaseURL+'/donate';

     //testimonials
     static Testimonials = this.BaseURL+'/testimonials';

     //annual reports
     static AnnualReports = this.BaseURL+'/annual/reports';


}

export default AppUrl;